enum SoftwareVersionType {
    Firmware = 0,
    Software = 1,
    Service = 2
}

export default SoftwareVersionType;